import {
  CustomError,
  getErrorData,
  type IGenericResponseRoot,
  type IErrorData
} from '../utils/getErrorData';
import { AuthService } from '../services/AuthService';
import { toast } from 'react-toastify';
import { api } from '../utils/api';
import {
  type IManagersData,
  type IManagerFromYandex
} from '@/types/IManagersFromYandex';

export interface IGetManagersOptions {
  signal: AbortSignal;
}

export type AbortErrorType = 'Abort';

export const getManagersFromYandex = async (
  options: IGetManagersOptions
): Promise<
  IGenericResponseRoot<IManagersData> | IErrorData | AbortErrorType
> => {
  const { signal } = options;

  try {
    const headers: Record<string, string> = {};

    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      void AuthService.checkUser();
      toast('Пользователь не авторизирован', { type: 'error' });
      throw new CustomError('Пользователь не авторизирован');
    }

    const response = await api.get<IGenericResponseRoot<IManagersData>>(
      '/admin/yandex-360/users',
      {
        headers,
        signal
      }
    );

    if (response.status === 500) {
      throw new CustomError(
        'При получении списка менеджеров произошла необработанная ошибка'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('Ошибка. Менеджеров не было найдено.');
    }

    if (response.data.meta.error !== null) {
      if (typeof response.data.meta.error === 'string') {
        throw new CustomError(response.data.meta.error);
      }
      if (typeof response.data.meta.error === 'object') {
        throw new CustomError(response.data.meta.error.message);
      }
    }

    return response.data;
  } catch (error) {
    const errorData = getErrorData(error);
    // eslint-disable-next-line no-console
    console.error('Ошибка при получении менеджеров:', error);
    return errorData;
  }
};

export const getManagerFromYandex = async (
  userId: string,
  options: IGetManagersOptions
): Promise<
  IGenericResponseRoot<IManagerFromYandex> | IErrorData | AbortErrorType
> => {
  const { signal } = options;

  try {
    const headers: Record<string, string> = {};

    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      void AuthService.checkUser();
      toast('Пользователь не авторизирован', { type: 'error' });
      throw new CustomError('Пользователь не авторизирован');
    }

    const response = await api.get<IGenericResponseRoot<IManagerFromYandex>>(
      `admin/yandex-360/user/${userId}`,
      {
        headers,
        signal
      }
    );

    if (response.status === 500) {
      throw new CustomError(
        'При получении менеджера произошла необработанная ошибка'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('Ошибка. Менеджер не был найден.');
    }

    if (response.data.meta.error !== null) {
      if (typeof response.data.meta.error === 'string') {
        throw new CustomError(response.data.meta.error);
      }
      if (typeof response.data.meta.error === 'object') {
        throw new CustomError(response.data.meta.error.message);
      }
    }

    return response.data;
  } catch (error) {
    const errorData = getErrorData(error);
    // eslint-disable-next-line no-console
    console.error('Ошибка при получении менеджера:', error);
    return errorData;
  }
};
